/**
 * Global circular loading indicator, shown automatically whenever an
 * in-flight operation (API call, export, etc.) takes longer than 1 second.
 * Fast requests never see it — the show is delayed, not the request itself.
 *
 * Usage: const token = loadingIndicator.begin(); /* ... await work ... *\/ loadingIndicator.end(token);
 * Multiple concurrent callers are ref-counted, so the indicator only
 * disappears once every tracked operation has finished.
 */
const SHOW_DELAY_MS = 1000;
const OVERLAY_ID = 'rc5-global-loading-indicator';

let activeCount = 0;
let showTimer = null;
let overlayEl = null;

function ensureOverlay() {
  if (overlayEl && overlayEl.isConnected) return overlayEl;
  overlayEl = document.getElementById(OVERLAY_ID);
  if (overlayEl) return overlayEl;
  overlayEl = document.createElement('div');
  overlayEl.id = OVERLAY_ID;
  overlayEl.setAttribute('role', 'status');
  overlayEl.setAttribute('aria-live', 'polite');
  overlayEl.setAttribute('aria-label', 'Загрузка');
  overlayEl.innerHTML = '<span class="rc5-global-loading-indicator__spinner"></span>';
  (document.body || document.documentElement).appendChild(overlayEl);
  return overlayEl;
}

function showOverlay() {
  ensureOverlay().classList.add('is-visible');
}

function hideOverlay() {
  if (overlayEl) overlayEl.classList.remove('is-visible');
}

/** Call at the start of a slow-ish operation. Returns a token to pass to `end()`. */
function begin() {
  activeCount += 1;
  if (activeCount === 1 && !showTimer) {
    showTimer = setTimeout(() => {
      showTimer = null;
      if (activeCount > 0) showOverlay();
    }, SHOW_DELAY_MS);
  }
  return activeCount;
}

/** Call when the operation started by a matching `begin()` finishes (success or error). */
function end() {
  activeCount = Math.max(0, activeCount - 1);
  if (activeCount === 0) {
    if (showTimer) {
      clearTimeout(showTimer);
      showTimer = null;
    }
    hideOverlay();
  }
}

export const loadingIndicator = { begin, end };
